import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default {
  name: 'lab_park_sel',
  props: {
    formData: {
      type: Object,
      default: {}
    },
    funName: {
      type: String,
      default: ''
    }
  },
  components: {
    labSel: function labSel() {
      return import('../org/lab_sel.vue');
    },
    areaSel: function areaSel() {
      return import('../org/lab_area_sel.vue');
    }
  },
  data: function data() {
    return {
      formLabelWidth: '110px',
      enterprise_show: false,
      area_show: false,
      rules: {},
      isBusiness: localStorage.getItem('accountCategory') === 'Business' ? true : false
    };
  },
  methods: {
    sel: function sel(data) {
      this.$emit('child-bind-sel', data);
    } // 选择企业
    ,
    labSel: function labSel(data) {
      if (data) {
        this.formData.labId = data.id;
        this.$set(this.formData, 'labName', data.name);
        this.$set(this.formData, 'areaId', '');
        this.$set(this.formData, 'areaName', '');
      }
      this.enterprise_show = false;
    } // 选择养殖区域
    ,
    areaSel: function areaSel(data) {
      if (data) {
        this.$set(this.formData, 'areaId', data.id);
        this.$set(this.formData, 'areaName', data.name);
      }
      this.area_show = false;
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    submitFormData: function submitFormData() {
      var _this = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          _this.$api[_this.funName](_this.formData.id, _this.saveFormDataProcess({
            labId: _this.formData.labId,
            areaId: _this.formData.areaId
          })).then(function (res) {
            if (res.data) {
              _this.$message.success('绑定成功');
              _this.sel(true);
            } else {
              _this.$message.error('绑定失败');
            }
          });
        }
      });
    }
  }
};